<div (click)="onClose()" class="fixed inset-0 bg-black/85 backdrop-blur-md flex justify-center items-center z-50 no-scrollbar cursor-default">
    <div (click)="$event.stopPropagation()" class="relative flex flex-col justify-center items-center overflow-hidden bg-slate-900 text-white rounded-lg border border-slate-800 shadow-2xl transition-all duration-300 max-w-[75vw] max-h-[75vh]">
        <!-- Header with Title -->
        @if (title) {
        <div class="absolute top-0 left-0 right-0 z-10 flex items-center justify-between p-3 bg-gradient-to-b from-black/70 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
            <h2 class="text-sm font-semibold truncate text-white/90 drop-shadow pr-8 select-none">
                {{ title }}
            </h2>
        </div>
        }
        
        <!-- Close Button -->
        <button type="button" (click)="onClose()" 
            class="absolute top-3 right-3 z-20 flex justify-center items-center w-8 h-8 rounded-full bg-black/40 hover:bg-black/70 text-white/80 hover:text-white border border-white/10 transition-all duration-150 backdrop-blur-sm focus:outline-none cursor-pointer">
            <i class="fas fa-xmark text-lg"></i>
        </button>

        <!-- Image wrapper -->
        <div class="flex items-center justify-center p-2">
            <img [src]="imageUrl" 
                class="max-w-[73vw] max-h-[73vh] rounded object-contain block mx-auto select-none pointer-events-none"
                alt="Notice Image" />
        </div>
    </div>
</div>
